























































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import User from '../../../store/entities/user'
import userAjax from '@/lib/userAjax'
@Component
export default class EditUser extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    user:User=new User();
    flowRoles: any=[]
    flowRoleList: any=[]
    created(){
        // 获取角色列表
        userAjax.get('/api/services/app/BaseUserEmpRole/GetRoleList').then(res => {
          this.flowRoleList = res.data.result.items
        })
    }
    get roles(){
        return this.$store.state.user.roles;
    }
    save(){
        (this.$refs.userForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'user/update',
                    data:this.user
                });
                (this.$refs.userForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
                // 流程角色批量更新
                userAjax.post(`/api/services/app/BaseUserEmpRole/BatchUpdateEmpByRolesAsync?AbpUserId=${this.user.id}`,this.flowRoles)
            }
        })
    }
    cancel(){
        (this.$refs.userForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }else{
            this.flowRoles = []
            this.user=Util.extend(true,{},this.$store.state.user.editUser)
            userAjax.get(`/api/services/app/BaseUserEmpRole/GetRoleList?AbpUserId=${this.user.id}`).then(res => {
              let data = res.data.result.items
              data.forEach((role:any) => {
                let map = new Map()
                this.flowRoles.push(role.id)
                // 去重
                this.flowRoles = this.flowRoles.filter((item:any) => !map.has(item) && map.set(item, 1))
              });
            })
        }
    }
    userRule={
        userName:[{required: true,message:'用户名不能为空',trigger: 'blur'}],
        name:[{required:true,message:'姓名不能为空',trigger: 'blur'}],
        // surname:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Surname')),trigger: 'blur'}],
        emailAddress:[{required:true,message:'邮箱不能为空',trigger: 'blur'},{type: 'email'}],
        // phoneNumber:[{required:true,message:'手机号不能为空',trigger: 'blur'}],
        position:[{required:true,message:'职位不能为空',trigger: 'blur'}],
    }
}
